module.exports = __webpack_public_path__ + "static/media/boxinggloves.6f73df2e.svg";